import { applyMomentLocale } from 'i18n/dateLocale';

const updateDateLocaleES = (language: string): void => {
  applyMomentLocale(language);
};

export default updateDateLocaleES;
